import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=35bb0a49"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports